export default (state = [], action) => {
  switch (action.type){
    case 'SET_ORDERLIST':
		var newState={...state, page: action.page, rowsPerPage:action.rowsPerPage};
		return newState;
			break;
	case 'SET_PAGE':
		var newState={...state, page: action.page};
		return newState;
			break;
	case 'SET_ROWSPERPAGE':
		var newState={...state, page: 0, rowsPerPage:action.rowsPerPage};
		return newState;
			break;
	case 'SET_PROCESSING':
//		console.log("setProcessing: "+action.processing);
		var newState={...state, processing: action.processing};
//		console.log("newState");
//		console.log(newState);
		return newState;
			break;
	case 'SET_MAXORDERS':
//		console.log("SET_MAXORDERS: "+action.maxorders);
		var newState={...state, maxorders: action.maxorders};
		return newState;
			break;
    default:
        return state;
  }
};